var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomePageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 196,
    viewBox: "0 0 183 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.001 72.0308H0V178.375H149.001V72.0308Z",
    fill: "#9B4F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.503 34.438H135.94V9.21405C135.94 4.12756 140.058 0 145.133 0C147.67 0 149.971 1.02842 151.635 2.69612C153.271 4.33602 154.311 6.61522 154.325 9.13067V9.21405L154.311 25.224C154.311 25.3074 154.311 25.3908 154.325 25.4603V25.9467L154.352 25.9328C154.713 30.6857 158.664 34.438 163.503 34.438Z",
    fill: "#86A7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.695 19.6511V25.224C172.695 27.7672 171.669 30.0742 170.005 31.728C168.355 33.3957 166.054 34.4242 163.517 34.4242C158.678 34.4242 154.713 30.6718 154.366 25.9189L172.695 19.6511Z",
    fill: "#D3DFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.133 0C144.939 0 144.744 0.013895 144.564 0.0277925C144.439 0.04169 144.315 0.0416917 144.204 0.0555892C144.065 0.0694867 143.94 0.0833834 143.816 0.111178C143.732 0.125076 143.663 0.138972 143.58 0.152869C143.483 0.166767 143.386 0.194565 143.289 0.208463C143.15 0.236258 143.011 0.26405 142.873 0.305743C142.679 0.361333 142.485 0.416926 142.29 0.486413C142.193 0.514208 142.096 0.555898 141.999 0.583693C141.902 0.611488 141.805 0.653183 141.722 0.694876C141.583 0.750466 141.459 0.806054 141.334 0.861644C141.223 0.917234 141.112 0.958928 141.001 1.02842C140.973 1.04231 140.932 1.05621 140.904 1.084C140.807 1.13959 140.71 1.19519 140.613 1.25078C140.225 1.47314 139.85 1.70939 139.518 1.98734C139.421 2.07073 139.31 2.15412 139.226 2.2236C139.115 2.32089 139.018 2.40427 138.908 2.50155C138.797 2.59884 138.7 2.69612 138.603 2.7934C138.325 3.07135 138.076 3.3632 137.826 3.68284C137.715 3.82182 137.618 3.96079 137.521 4.09977C137.216 4.57228 136.953 5.05869 136.717 5.5868C136.661 5.71188 136.606 5.85086 136.551 5.97593C136.398 6.37896 136.273 6.79589 136.176 7.21281C136.149 7.36568 136.121 7.50466 136.093 7.64364C136.038 7.93548 135.996 8.22733 135.982 8.51918V137.738H13.1157V14.37C13.1157 6.43455 19.5349 0.0138941 27.4376 0.0138941H145.133V0Z",
    fill: "#D3DFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.87 13.1749H27.6318V18.0946H120.87V13.1749Z",
    fill: "#ADC3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.647 27.5727H27.6318V32.4924H113.647V27.5727Z",
    fill: "#ADC3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.113 41.9844H27.6318V46.9041H109.113V41.9844Z",
    fill: "#ADC3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.87 56.3823H27.6318V61.302H120.87V56.3823Z",
    fill: "#ADC3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.215 70.9608H63.6655V75.8805H114.215V70.9608Z",
    fill: "#ADC3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M135.982 76.478V137.71H13.1157V71.1414L51.4924 103.147C53.6137 104.912 56.3865 105.593 59.1178 105.204C59.9081 105.093 60.7261 105.051 61.5302 105.065L87.6924 105.802C88.5936 105.83 89.4948 105.941 90.3682 106.135C93.0856 106.719 95.914 106.191 98.16 104.523L135.982 76.478Z",
    fill: "#86A7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0259 116.114L54.9999 117.253L8.76211 168.646L0.0136719 178.375V72.0309L56.0259 116.114Z",
    fill: "#F9A654"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.001 72.0309L92.9746 116.114L149.001 178.375V72.0309Z",
    fill: "#F9A654"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0001 117.253L8.76231 168.646L0 170.578V151.678C23.112 135.07 49.0384 115.822 54.9724 115.405L55.0001 117.253Z",
    fill: "#F25E2E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.001 117.253L140.239 168.646L149.001 170.578V151.678C125.889 135.07 99.9627 115.822 94.0287 115.405L94.001 117.253Z",
    fill: "#F25E2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.001 178.375H0L0.0277305 164.38L51.3677 117.698C54.0574 115.252 57.565 113.89 61.2114 113.89H87.3874C90.9644 113.89 94.4305 115.21 97.1063 117.587L149.139 163.893L149.001 178.375Z",
    fill: "#F9A654"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.117 188.148C169.112 178.129 169.112 161.886 159.117 151.867C149.122 141.848 132.917 141.848 122.923 151.867C112.928 161.886 112.928 178.129 122.923 188.148C132.917 198.167 149.122 198.167 159.117 188.148Z",
    fill: "#5B4DAD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.826 188.15C176.821 178.131 176.821 161.888 166.826 151.869C156.831 141.85 140.626 141.85 130.631 151.869C120.637 161.888 120.637 178.131 130.631 188.15C140.626 198.169 156.831 198.169 166.826 188.15Z",
    fill: "url(#paint0_linear_1_1095)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.179 183.908C146.959 183.908 145.794 183.394 144.963 182.476L135.909 172.456C135.133 171.594 135.188 170.26 136.062 169.482C136.921 168.704 138.252 168.759 139.029 169.635L148.082 179.655C148.096 179.669 148.138 179.711 148.207 179.697C148.276 179.683 148.304 179.641 148.304 179.613L158.051 157.377C158.522 156.307 159.756 155.821 160.824 156.293C161.891 156.766 162.376 158.003 161.905 159.073L152.158 181.309C151.562 182.671 150.342 183.616 148.886 183.852C148.651 183.894 148.415 183.908 148.179 183.908Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1095",
    x1: 126.736,
    y1: 154.137,
    x2: 165.109,
    y2: 190.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePageIcon);
export default __webpack_public_path__ + "static/media/welcome-page-icon.3dcdebfe5b4a7b441da925760d008641.svg";
export { ForwardRef as ReactComponent };